/**
 * Next.jsのカスタムAppコンポーネント
 * アプリケーション全体の初期化と共通レイアウトの適用を行う。
 * - RecoilのRecoilRootでグローバルステート管理を提供
 * - Layoutコンポーネントで共通のヘッダー・フッターを適用
 * - 開発環境ではMSW（Mock Service Worker）を初期化してAPIモックを有効化
 */
import 'swiper/css';
import 'swiper/css/navigation';
import '../styles/globals.css';
import '../styles/common.css';
import '../styles/common_customize.css';
import type { AppProps } from 'next/app';
import { RecoilRoot } from 'recoil';
import { useEffect, useState } from 'react';
import Layout from '../components/Layout';

/** 開発環境かどうかの判定フラグ（開発環境ではAPIモックを有効化する） */
const API_MOCKING = process.env.NODE_ENV === 'development';

const MyApp = ({ Component, pageProps }: AppProps) => {
  // MSWが初期化完了するまでレンダリングを抑制する（モックが不要な場合は即時レンダリング）
  const [shouldRender, setShouldRender] = useState(!API_MOCKING);
  useEffect(() => {
    /** 開発環境でのMSW初期化処理 */
    async function initMocks() {
      const MockServer = () => import('../mocks/worker');
      await MockServer();
      setShouldRender(true);
    }

    if (API_MOCKING) {
      initMocks();
    }
  }, []);

  if (!shouldRender) {
    return null;
  }

  return (
    <RecoilRoot>
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </RecoilRoot>
  );
};

export default MyApp;
